// Contenu du site Geodonnée : coordonnées, services, expertise, formations.
// Chaque service et chaque formation a sa page (`slug`).

export const companyInfo = {
  name: "Geodonnée",
  contact: {
    email: "info@geodonnee.com",
    street: "30 rue des Prés",
    city: "Gatineau",
    region: "QC",
    postalCode: "J9A 3G8",
  },
};

export const services = [
  {
    id: "1",
    slug: "traitement-donnees-geospatiales",
    title: "Traitement de données géospatiales",
    description:
      "Nettoyage, validation et conversion de grands volumes de données géographiques, pour des jeux fiables et prêts à l'emploi.",
    icon: "Database",
    capabilities: [
      "Traitement par lots automatisé",
      "Nettoyage et validation",
      "Conversion multiformat",
      "Optimisation des performances",
    ],
    intro:
      "Données héritées, formats hétérogènes, géométries invalides, attributs incomplets : avant toute analyse ou diffusion, les données doivent être remises en état. Nous construisons des chaînes de traitement reproductibles qui contrôlent, corrigent et convertissent vos données, et qui se relancent à chaque mise à jour.",
    details: [
      {
        titre: "Traitement par lots automatisé",
        texte:
          "Des milliers de fichiers ou de tables traités en une passe, avec un journal de chaque opération.",
      },
      {
        titre: "Nettoyage et validation",
        texte:
          "Géométries réparées, doublons retirés, attributs contrôlés selon vos règles métier.",
      },
      {
        titre: "Conversion multiformat",
        texte:
          "Shapefile, GeoPackage, DWG, GeoJSON, PostGIS, Oracle Spatial ou raster : passage d'un format à l'autre sans perte d'information.",
      },
      {
        titre: "Optimisation des performances",
        texte:
          "Index spatiaux, découpage et parallélisation, pour que les traitements longs le soient beaucoup moins.",
      },
    ],
    livrables: [
      "Chaîne de traitement documentée (FME, Python ou SQL)",
      "Rapport de contrôle qualité des données",
      "Jeux de données corrigés dans le format cible",
      "Séance de transfert à vos équipes",
    ],
    outils: ["FME", "Python et GDAL", "PostgreSQL et PostGIS", "QGIS"],
    formations: ["automatisation-fme-desktop", "python-geomatique"],
  },
  {
    id: "2",
    slug: "automatisation-sig",
    title: "Automatisation SIG",
    description:
      "Automatisation des processus géomatiques récurrents, pour réduire les coûts et gagner en fiabilité.",
    icon: "BarChart3",
    capabilities: [
      "Scripts automatisés",
      "Flux de travail personnalisés",
      "Intégration d'API",
      "Surveillance des traitements",
    ],
    intro:
      "Mises à jour hebdomadaires, exports pour des partenaires, contrôles de cohérence : les tâches répétées à la main coûtent du temps et produisent des erreurs. Nous les transformons en traitements planifiés, surveillés et documentés, qui tournent sans intervention.",
    details: [
      {
        titre: "Scripts automatisés",
        texte:
          "Python, SQL ou FME, versionnés dans votre dépôt et lisibles par vos équipes.",
      },
      {
        titre: "Flux de travail personnalisés",
        texte:
          "Des enchaînements adaptés à vos sources, à vos règles et à vos destinations.",
      },
      {
        titre: "Intégration d'API",
        texte:
          "Connexion à des services web, à vos logiciels métier et à vos plateformes de diffusion.",
      },
      {
        titre: "Surveillance des traitements",
        texte:
          "Journaux d'exécution, alertes par courriel en cas d'échec et suivi des exécutions passées.",
      },
    ],
    livrables: [
      "Traitements planifiés sur votre serveur ou dans le nuage",
      "Code versionné et documenté",
      "Alertes et journaux d'exécution",
      "Guide d'exploitation pour vos équipes",
    ],
    outils: ["FME Flow", "Python", "PostgreSQL et PostGIS", "Tâches planifiées"],
    formations: ["automatisation-fme-desktop", "python-geomatique"],
  },
  {
    id: "3",
    slug: "diffusion-visualisation",
    title: "Diffusion et visualisation",
    description:
      "Portails cartographiques, services web et applications mobiles pour partager vos données géospatiales.",
    icon: "Map",
    capabilities: [
      "Portails cartographiques",
      "Applications mobiles",
      "Services WMS, WFS et tuiles",
      "Tableaux de bord",
    ],
    intro:
      "Une donnée utile est une donnée consultée. Nous publions vos projets sous forme de cartes web, de services normalisés OGC et d'outils de collecte terrain, avec la gestion des accès qui convient à chaque public.",
    details: [
      {
        titre: "Portails cartographiques",
        texte:
          "Cartes web interactives tirées de vos projets QGIS, avec recherche, impression et fiches d'objets.",
      },
      {
        titre: "Applications mobiles",
        texte:
          "Collecte et consultation sur le terrain, en ligne comme hors ligne, avec Lizpack Field.",
      },
      {
        titre: "Services WMS, WFS et tuiles",
        texte:
          "Services OGC publiés avec GeoServer, pour vos partenaires et vos logiciels.",
      },
      {
        titre: "Tableaux de bord",
        texte:
          "Indicateurs et cartes de synthèse pour suivre vos activités dans le temps.",
      },
    ],
    livrables: [
      "Portail ou application en production",
      "Services OGC configurés et sécurisés",
      "Gestion des utilisateurs et des droits",
      "Documentation et formation des administrateurs",
    ],
    outils: ["Lizmap et Lizpack", "GeoServer", "QGIS Server", "OpenLayers", "Leaflet"],
    formations: ["cartographie-web-openlayers", "qgis-fondamentaux"],
  },
  {
    id: "4",
    slug: "formation-accompagnement",
    title: "Formation et accompagnement",
    description:
      "Formations spécialisées et accompagnement technique pour rendre vos équipes autonomes.",
    icon: "Users",
    capabilities: [
      "Formation sur mesure",
      "Catalogue QGIS, FME, PostGIS et Python",
      "Soutien après la formation",
      "Transfert d'expertise",
    ],
    intro:
      "Nous formons les équipes qui exploiteront les outils après notre départ. Les sessions s'appuient sur des cas concrets, autant que possible sur vos propres données, et se prolongent par un accompagnement à la demande.",
    details: [
      {
        titre: "Formation sur mesure",
        texte:
          "Un programme construit à partir de vos projets, de vos données et du niveau de vos équipes.",
      },
      {
        titre: "Catalogue QGIS, FME, PostGIS et Python",
        texte:
          "Des sessions en présentiel à Gatineau ou à distance, en petits groupes.",
      },
      {
        titre: "Soutien après la formation",
        texte:
          "Réponses à vos questions et revues de vos premiers traitements une fois la session terminée.",
      },
      {
        titre: "Transfert d'expertise",
        texte:
          "Un accompagnement pendant un projet réel, jusqu'à ce que vos équipes en aient la maîtrise.",
      },
    ],
    livrables: [
      "Supports de cours et exercices corrigés",
      "Jeux de données d'exercice",
      "Soutien par courriel après la session",
    ],
    outils: ["QGIS", "FME", "PostgreSQL et PostGIS", "Python", "OpenLayers"],
    formations: ["formation-sur-mesure", "qgis-fondamentaux"],
  },
  {
    id: "5",
    slug: "cartes-web-developpement-sur-mesure",
    title: "Cartes web et développement sur mesure",
    description:
      "Cartes web, applications et logiciels développés pour vos besoins, de la maquette à la mise en production.",
    icon: "Code",
    capabilities: [
      "Cartes web interactives",
      "Applications web et mobiles",
      "API et intégrations",
      "Logiciels métier sur mesure",
    ],
    intro:
      "Quand aucun outil du marché ne correspond à votre besoin, nous le développons. Cartes web publiques ou internes, applications de saisie, tableaux de bord, API ou logiciels métier : nous concevons, développons et mettons en production des outils adaptés à vos données et à vos utilisateurs.",
    details: [
      {
        titre: "Cartes web interactives",
        texte:
          "Cartes publiques ou internes, avec recherche, filtres, fiches et impression, alimentées par vos données en direct.",
      },
      {
        titre: "Applications web et mobiles",
        texte:
          "Saisie, consultation et suivi sur le terrain ou au bureau, avec des écrans pensés pour vos utilisateurs.",
      },
      {
        titre: "API et intégrations",
        texte:
          "Des services qui relient vos bases spatiales à vos logiciels métier, à vos partenaires et à vos plateformes.",
      },
      {
        titre: "Logiciels métier sur mesure",
        texte:
          "Des outils développés pour un processus précis, documentés et maintenables par vos équipes ou par nous.",
      },
    ],
    livrables: [
      "Application en production et code source livré",
      "Documentation technique et guide d'utilisation",
      "Tests et procédure de déploiement",
      "Maintenance et évolutions à la demande",
    ],
    outils: ["React", "OpenLayers", "Leaflet", "Node.js", "Python", "PostgreSQL et PostGIS"],
    formations: ["cartographie-web-openlayers", "python-geomatique"],
  },
  {
    id: "6",
    slug: "sous-traitance-traitement-collecte",
    title: "Sous-traitance : traitement et collecte de données",
    description:
      "Des équipes en renfort pour traiter vos données à la main et collecter de nouvelles données, sur le terrain ou à distance.",
    icon: "ClipboardCheck",
    capabilities: [
      "Saisie et numérisation",
      "Vectorisation et mise à jour",
      "Contrôle qualité manuel",
      "Collecte de données terrain",
    ],
    intro:
      "Certains travaux ne s'automatisent pas : saisir des plans papier, vectoriser des images, corriger des données une par une, relever des objets sur le terrain. Nous prenons ces travaux en sous-traitance pour les entreprises et les organisations, avec des règles de saisie convenues ensemble et un contrôle qualité à chaque livraison.",
    details: [
      {
        titre: "Saisie et numérisation",
        texte:
          "Plans, registres et documents papier ou scannés transformés en données géoréférencées exploitables.",
      },
      {
        titre: "Vectorisation et mise à jour",
        texte:
          "Bâtiments, réseaux, parcelles ou occupation du sol tracés à partir d'images, puis tenus à jour.",
      },
      {
        titre: "Contrôle qualité manuel",
        texte:
          "Vérification et correction objet par objet, selon vos règles, avec un rapport des anomalies.",
      },
      {
        titre: "Collecte de données terrain",
        texte:
          "Relevés sur le terrain avec QField et LizPack Field, synchronisés au fil des journées.",
      },
    ],
    livrables: [
      "Données livrées dans votre format et votre système de coordonnées",
      "Règles de saisie et dictionnaire de données convenus",
      "Rapport de contrôle qualité à chaque livraison",
      "Suivi de l'avancement pendant le mandat",
    ],
    outils: ["QGIS", "QField et LizPack Field", "PostgreSQL et PostGIS", "FME"],
    formations: ["qgis-fondamentaux", "formation-sur-mesure"],
  },
];

export const expertiseDomains = [
  {
    category: "Traitement automatisé",
    skills: ["FME", "Python/GDAL", "ETL géospatial", "Cloud Processing", "Big Data", "Machine Learning"],
  },
  {
    category: "Bases de données",
    skills: ["PostgreSQL/PostGIS", "Oracle Spatial", "MongoDB", "InfluxDB", "ElasticSearch", "Redis"],
  },
  {
    category: "Diffusion web",
    skills: ["React/Vue.js", "Node.js", "GeoServer", "MapServer", "OpenLayers", "Leaflet"],
  },
  {
    category: "Formation",
    skills: ["ArcGIS Pro", "QGIS", "FME Desktop", "Python SIG", "Bases PostGIS", "Cartographie web"],
  },
];

export const formations = [
  {
    id: "1",
    slug: "qgis-fondamentaux",
    title: "QGIS fondamentaux",
    description:
      "Maîtrisez les bases de QGIS pour créer, analyser et visualiser vos données géospatiales avec efficacité.",
    public:
      "Techniciens, analystes et gestionnaires qui débutent avec QGIS ou qui viennent d'un autre logiciel SIG.",
    objectif:
      "À la fin de la formation, vous savez charger et organiser des données, les interroger, les symboliser et produire des cartes prêtes à diffuser.",
    duration: "3 jours (21 h)",
    heures: 21,
    level: "Débutant",
    format: "Présentiel ou virtuel",
    modes: ["Onsite", "Online"],
    topics: [
      "Interface et navigation QGIS",
      "Gestion des données vecteur et raster",
      "Symbologie et mise en page",
      "Requêtes spatiales de base",
      "Création de cartes professionnelles",
    ],
    prerequisites: [
      "Connaissances informatiques de base",
      "Notions de géographie recommandées",
    ],
    maxParticipants: 12,
  },
  {
    id: "2",
    slug: "automatisation-fme-desktop",
    title: "Automatisation FME Desktop",
    description:
      "Apprenez à automatiser vos traitements de données géospatiales avec FME Desktop et optimisez vos flux de travail.",
    public:
      "Géomaticiens et analystes qui convertissent, contrôlent ou intègrent régulièrement des données.",
    objectif:
      "Concevoir des traitements FME fiables et réutilisables, de la lecture des sources jusqu'au chargement en base de données.",
    duration: "4 jours (28 h)",
    heures: 28,
    level: "Intermédiaire",
    format: "Présentiel ou virtuel",
    modes: ["Onsite", "Online"],
    topics: [
      "Interface FME Workbench",
      "Lecture et écriture de formats",
      "Transformations de données",
      "Automatisation par scripts",
      "Intégration avec les bases de données",
      "Optimisation des performances",
    ],
    prerequisites: [
      "Expérience SIG recommandée",
      "Connaissance des formats de données",
    ],
    maxParticipants: 10,
  },
  {
    id: "3",
    slug: "postgis-avance",
    title: "PostgreSQL et PostGIS avancé",
    description:
      "Développez vos compétences en bases de données spatiales avec PostgreSQL et PostGIS pour des projets complexes.",
    public:
      "Analystes et développeurs qui stockent ou interrogent des données spatiales dans une base de données.",
    objectif:
      "Modéliser, indexer et interroger des données spatiales dans PostgreSQL, et obtenir des requêtes rapides sur de gros volumes.",
    duration: "3 jours (21 h)",
    heures: 21,
    level: "Avancé",
    format: "Présentiel",
    modes: ["Onsite"],
    topics: [
      "Installation et configuration de PostGIS",
      "Types de données spatiales",
      "Requêtes spatiales complexes",
      "Indexation spatiale",
      "Optimisation des performances",
      "Intégration avec des applications web",
    ],
    prerequisites: ["Connaissances SQL solides", "Expérience des SIG requise"],
    maxParticipants: 8,
  },
  {
    id: "4",
    slug: "cartographie-web-openlayers",
    title: "Cartographie web avec OpenLayers",
    description:
      "Créez des applications cartographiques web interactives et modernes avec OpenLayers et JavaScript.",
    public:
      "Développeurs web et géomaticiens qui veulent publier des cartes interactives.",
    objectif:
      "Construire une application cartographique complète : couches, services OGC, interactions et mise en production.",
    duration: "5 jours (35 h)",
    heures: 35,
    level: "Intermédiaire",
    format: "Hybride",
    modes: ["Blended"],
    topics: [
      "Fondamentaux de la cartographie web",
      "API OpenLayers",
      "Intégration de services WMS et WFS",
      "Interactions utilisateur",
      "Développement d'applications complètes",
      "Optimisation et déploiement",
    ],
    prerequisites: [
      "Connaissances HTML, CSS et JavaScript",
      "Notions de cartographie",
    ],
    maxParticipants: 10,
  },
  {
    id: "5",
    slug: "python-geomatique",
    title: "Python pour la géomatique",
    description:
      "Automatisez vos analyses géospatiales et développez des outils personnalisés avec Python et ses bibliothèques spécialisées.",
    public:
      "Géomaticiens qui veulent automatiser leurs analyses et créer leurs propres outils.",
    objectif:
      "Écrire des scripts Python qui lisent, transforment et analysent des données vecteur et raster, puis les intégrer à QGIS.",
    duration: "4 jours (28 h)",
    heures: 28,
    level: "Intermédiaire",
    format: "Virtuel",
    modes: ["Online"],
    topics: [
      "Environnement Python géospatial",
      "Bibliothèques GDAL, Shapely et Fiona",
      "Traitement de données raster et vecteur",
      "Géotraitement automatisé",
      "Création de scripts d'analyse",
      "Intégration avec QGIS",
    ],
    prerequisites: [
      "Bases de programmation Python",
      "Expérience SIG requise",
    ],
    maxParticipants: 12,
  },
  {
    id: "6",
    slug: "formation-sur-mesure",
    title: "Formation sur mesure",
    description:
      "Une formation adaptée aux besoins de votre organisation, à vos outils et à vos projets.",
    public:
      "Équipes et organisations qui ont des besoins, des outils ou des données qui leur sont propres.",
    objectif:
      "Un programme construit avec vous à partir de vos projets, de vos données et du niveau de vos équipes.",
    duration: "Variable",
    heures: null,
    level: "Tous niveaux",
    format: "Présentiel ou virtuel",
    modes: ["Onsite", "Online"],
    topics: [
      "Analyse des besoins de votre équipe",
      "Contenu adapté à vos données",
      "Cas d'usage de votre organisation",
      "Soutien après la formation inclus",
    ],
    prerequisites: ["Définis selon les objectifs"],
    maxParticipants: 20,
  },
];

export const serviceParSlug = (slug) => services.find((s) => s.slug === slug);
export const formationParSlug = (slug) =>
  formations.find((f) => f.slug === slug);

/**
 * Plateformes présentées dans le carrousel du hero. Captures prises sur
 * l'environnement de démonstration de LizPack.
 */
export const vedettes = [
  {
    nom: "LizPack Viewer",
    accroche: "Vos couches, une carte, un lien.",
    texte:
      "Composez une carte dans le navigateur avec les couches de vos projets et des services WMS ou WFS, analysez-la, puis partagez-la par un lien ou intégrez-la à votre site.",
    points: ["Plusieurs projets, une carte", "Outils d'analyse", "Partage et intégration"],
    lien: "https://field.lizpack.com/viewer",
    lienLibelle: "Ouvrir LizPack Viewer",
    systeme: "Web",
    image: "/captures/viewer-paris-velo.webp",
    alt: "LizPack Viewer : carte de Paris avec les aménagements cyclables en bleu, les espaces verts et les arrondissements.",
  },
  {
    nom: "LizPack Field",
    accroche: "La collecte terrain, du bureau au mobile.",
    texte:
      "Préparez un projet dans QGIS, envoyez-le sur les téléphones de vos équipes avec QField, et récupérez les relevés automatiquement, même après une journée sans réseau.",
    points: ["QField sur Android et iOS", "Travail hors ligne", "Liaison PostGIS"],
    lien: "https://lizpack.com/lizpack-field",
    lienLibelle: "Découvrir LizPack Field",
    systeme: "Web, Android, iOS",
    image: "/captures/field-tableau-de-bord.webp",
    alt: "Tableau de bord de LizPack Field : projets, modifications terrain, traitements, cartes et graphique des synchronisations.",
  },
  {
    nom: "LizPack",
    accroche: "Hébergement Lizmap et QGIS Server.",
    texte:
      "Une instance Lizmap avec QGIS Server, PostGIS et cache de tuiles, en ligne en quelques minutes, avec sous-domaine et HTTPS automatiques. Vous publiez depuis QGIS, nous entretenons le serveur.",
    points: ["Lizmap Web Client", "QGIS Server", "PostGIS intégré"],
    lien: "https://lizpack.com/hebergement-lizmap",
    lienLibelle: "Découvrir LizPack",
    systeme: "Web",
    image: "/captures/lizpack-tableau-de-bord.webp",
    alt: "Tableau de bord de l'espace client LizPack : instances actives, projets QGIS, bases de données et stockage utilisé.",
  },
  {
    nom: "GeoServer Cloud",
    accroche: "Vos couches WMS et WFS, sans rien installer.",
    texte:
      "Un espace GeoServer isolé, inclus avec votre compte LizPack : publiez une couche depuis un fichier ou directement depuis la base d'une instance, et administrez-la dans la console.",
    points: ["Services WMS et WFS", "Console d'administration", "Connexion à vos bases"],
    lien: "https://lizpack.com/geoserver-cloud",
    lienLibelle: "Découvrir GeoServer Cloud",
    systeme: "Web",
    image: "/captures/lizpack-geoserver.webp",
    alt: "Espace GeoServer de LizPack : dépôt de données, connexion à la base d'une instance et couches publiées.",
  },
];

/** Produits LizPack, avec la page de chacun sur lizpack.com. */
export const produitsLizpack = [
  {
    icon: "Smartphone",
    nom: "LizPack Field",
    desc: "Collecte terrain avec QField sur Android et iOS, en ligne comme hors ligne, synchronisée avec PostGIS.",
    lien: "https://lizpack.com/lizpack-field",
  },
  {
    icon: "Map",
    nom: "LizPack Viewer",
    desc: "Composez une carte avec les couches de vos projets et des services WMS ou WFS, puis partagez-la par un lien.",
    lien: "https://field.lizpack.com/viewer",
  },
  {
    icon: "Layers",
    nom: "LizPack",
    desc: "Hébergement Lizmap managé avec QGIS Server, PostGIS et cache de tuiles, en ligne en quelques minutes.",
    lien: "https://lizpack.com/hebergement-lizmap",
  },
  {
    icon: "Upload",
    nom: "LizPack Publisher",
    desc: "Extension QGIS gratuite : publiez vos projets sur votre instance Lizmap sans quitter QGIS Desktop.",
    lien: "https://lizpack.com",
  },
  {
    icon: "LayoutDashboard",
    nom: "Modules Lizmap",
    desc: "Tableaux de bord composés dans QGIS et MapBuilder, activés en moins d'une minute sur votre instance.",
    lien: "https://lizpack.com",
  },
  {
    icon: "ShoppingBag",
    nom: "LizPack Catalogue",
    desc: "Cataloguez, diffusez et vendez vos données géographiques : boutique, téléchargements, WMS et WFS.",
    lien: "https://lizpack.com/lizpack-catalogue",
  },
  {
    icon: "Database",
    nom: "Bases de données PostGIS",
    desc: "Bases PostgreSQL/PostGIS dédiées, en connexion SSL, accessibles depuis QGIS Desktop et pgAdmin.",
    lien: "https://lizpack.com/postgresql-postgis-manage",
  },
  {
    icon: "Server",
    nom: "GeoServer Cloud",
    desc: "Un espace GeoServer isolé, avec services WMS et WFS et console d'administration, sans rien installer.",
    lien: "https://lizpack.com/geoserver-cloud",
  },
];

export const methode = [
  {
    titre: "Cadrage",
    texte:
      "Un appel de 30 minutes pour comprendre vos données, vos outils et ce que vous voulez obtenir.",
  },
  {
    titre: "Proposition",
    texte:
      "Un périmètre, des livrables et un prix fixés par écrit avant de commencer.",
  },
  {
    titre: "Réalisation",
    texte:
      "Des traitements construits sur vos données réelles, montrés au fil de l'eau.",
  },
  {
    titre: "Transfert",
    texte:
      "Documentation, code versionné et séance de transfert, pour que vos équipes reprennent la main.",
  },
];

export const faq = [
  {
    q: "Travaillez-vous uniquement à Gatineau ?",
    r: "Non. Nous sommes établis à Gatineau et intervenons sur place dans la région de Gatineau et d'Ottawa, et à distance partout au Québec et au Canada. Les formations se donnent en présentiel ou en virtuel.",
  },
  {
    q: "Avec quels logiciels travaillez-vous ?",
    r: "Principalement QGIS, FME, PostgreSQL/PostGIS, Python, GeoServer et Lizmap. Nous intervenons aussi sur des environnements ArcGIS lorsque vos données y vivent.",
  },
  {
    q: "Nos équipes pourront-elles maintenir les traitements ?",
    r: "Oui, c'est l'objectif. Chaque mandat est livré avec sa documentation, ses scripts versionnés et une séance de transfert. Une formation peut compléter le mandat.",
  },
  {
    q: "Combien coûte un mandat ?",
    r: "Cela dépend du volume de données et du périmètre. Après un premier appel gratuit, nous envoyons une proposition chiffrée avec les livrables. Les tarifs des formations sont communiqués sur demande.",
  },
  {
    q: "Développez-vous des cartes web et des applications sur mesure ?",
    r: "Oui. Nous concevons et développons des cartes web, des applications web et mobiles, des API et des logiciels métier adaptés à vos données, de la maquette à la mise en production, avec le code source et la documentation livrés.",
  },
  {
    q: "Les formations peuvent-elles se faire sur nos propres données ?",
    r: "Oui, lorsque c'est pertinent. Les sessions se donnent en petits groupes, en présentiel à Gatineau ou à distance, et la formation sur mesure se construit à partir de vos projets et du niveau de vos équipes.",
  },
  {
    q: "Peut-on essayer LizPack, LizPack Field et LizPack Viewer ?",
    r: "Oui. LizPack propose un essai gratuit, LizPack Field est gratuit jusqu'à 200 Mo et LizPack Viewer est inclus avec un compte LizPack Field. Nous pouvons aussi vous accompagner pour publier vos premiers projets.",
  },
  {
    q: "Combien de temps pour démarrer ?",
    r: "Nous revenons vers vous sous 24 h ouvrables. Un appel de 30 minutes permet de cadrer le besoin, puis nous envoyons une proposition avec le périmètre, les livrables et le calendrier.",
  },
  {
    q: "Quel est le lien entre Geodonnée et LizPack ?",
    r: "Geodonnée développe et opère LizPack, sa plateforme d'hébergement et de diffusion de données géospatiales (Lizmap, QGIS Server, PostGIS, GeoServer et collecte terrain avec QField).",
  },
];
